import { Location } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CodeSystemService } from 'app/mdm/terminology/codesystem/services/codesystem.service';
import { AttributeDatatype } from 'app/mdm/terminology-lib/services/attribute-datatype';
import { CodeSystem, CodeSystemConcept } from 'app/mdm/terminology-lib/services/codesystem';
import { saveAs } from 'file-saver';
import { NzMessageService } from 'ng-zorro-antd/message';
import { HttpResponse } from '@angular/common/http';

@Component({
  templateUrl: './codesystem-view.component.html',
})
export class CodeSystemViewComponent implements OnInit {
  public search: string;
  public maxAttributes: number;
  public codeSystem: CodeSystem;
  public validFromVisible = true;
  public validToVisible = true;
  @ViewChild('importConcepts') importFileInput: ElementRef;

  constructor(
    private codeSystemService: CodeSystemService,
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private location: Location,
    private messageService: NzMessageService
  ) {}

  public ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.initCodeSystem(id);
  }

  private initCodeSystem(id: string): void {
    this.codeSystemService.getCodeSystem(id).subscribe((r) => {
      this.codeSystem = r;
      if (r.notes && r.notes.hidden) {
        this.validFromVisible = r.notes.hidden.indexOf('validFrom') === -1;
        this.validToVisible = r.notes.hidden.indexOf('validTo') === -1;
        this.maxAttributes = 3 + (this.validFromVisible ? 0 : 1) + (this.validToVisible ? 0 : 1);
      }
    });
  }

  public touchImportConceptsInput(): void {
    this.importFileInput.nativeElement.click();
  }

  private getCurrentLang(): string {
    return this.translateService.currentLang;
  }

  public goBack(): void {
    this.location.back();
  }

  public formatAttributeValue(attributeId: string, concept: CodeSystemConcept): string {
    if (!concept || !concept.attributes || !concept.attributes[attributeId]) {
      return '';
    }
    const value = concept.attributes[attributeId];
    const attr = this.codeSystem.attributes.find((a) => a.id === attributeId);
    if (attr.datatype === AttributeDatatype.translations) {
      return value[this.getCurrentLang()] || value['et']; //FIXME remove dis
    }
    return value;
  }

  public deleteConcept(id: number): void {
    this.codeSystemService.removeConcept(this.codeSystem.id, id).subscribe(() => this.ngOnInit());
  }

  public exportConcepts(): void {
    this.codeSystemService.exportConcepts(this.codeSystem.id);
  }

  public importCsConcepts(event: any): void {
    const file = event.target.files[0];
    if (!!file) {
      const id = this.messageService.loading(this.translateService.instant('core.msg.in-progress'), {
        nzDuration: 0,
      }).messageId;
      this.codeSystemService.importConcepts(this.codeSystem.id, file).subscribe((e) => {
        if (e instanceof HttpResponse) {
          this.ngOnInit();
          this.messageService.remove(id);
        }
      });
    }
  }

  public importEsthifConcepts(): void {
    this.codeSystemService.importEsthifConcepts(this.codeSystem.id).subscribe(() => {
      this.initCodeSystem(this.codeSystem.id);
      this.messageService.success(this.translateService.instant('term.cs-03.msg.import-success'));
    });
  }

  public exportCodesystem(full: boolean): void {
    const exp = Object.assign({}, this.codeSystem);
    if (!full) {
      delete exp.concepts;
    }
    saveAs(new Blob([JSON.stringify(exp, null, 2)], { type: 'application/json' }), `${exp.id}.json`);
  }
}
